//该文件用于创建Vuex核心store

//引入vue核心库
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
//使用vuex插件，需要引入vue
Vue.use(Vuex)

//actions用于响应组件中的动作
const actions = {
	//被绕过的actions
	addOdd(context, value) {
		if (context.state.sum % 2) {
			context.commit('ADD', value)
		}
	},
	addWait(context, value) {
		setTimeout(() => {
			context.commit('ADD', value)
		}, 1000);
	},
	addset(context, value) {
		setTimeout(() => {
			context.commit('setList', value)
		}, 1000);
	},

}
//mutations用于操作state中的数据
const mutations = {
	ADD(state, value) {
		let a = state.list[state.index].mlptMenuFoodcategoryList
		console.log('ADDA', state.list)
		// console.log('value', value)
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					item.num++;
					state.count++;
					console.log('ADDITem', item)
					console.log('ADD', state.list)
					// foodList.foodcategoryNum++
				}
			})
		})
		console.log('ADD', state.list)
	},
	ADD2(state, value) {
		console.log('ADD2A', value)
		let a = state.list[value.index].mlptMenuFoodcategoryList
		// console.log('ADDA', state.list)
		// console.log('value', value)
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					item.num++;
					state.count++;
					// console.log('ADDITem',item)
					// console.log('ADD', state.list)
					// foodList.foodcategoryNum++
				}
			})
		})
		// console.log('ADD222', state.list)
		let d = state.list[value.index].mlptMenuFoodList
		d.forEach((food) => {
			if (food.id == value.id) {
				food.num++;
			}
		})
		console.log('ADD222', state.list)
	},
	ADDCOUNT(state, value) {
		let a = state.list[state.index].mlptMenuFoodcategoryList
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					foodList.foodcategoryNum++

				}


			})
		})
		// console.log('a', a)
		console.log('ADDCOUNT', state.list)
	},
	ADDCOUNT2(state, value) {
		let a = state.list[value.index].mlptMenuFoodcategoryList
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					foodList.foodcategoryNum++

				}


			})
		})
		// console.log('a', a)
		console.log('ADDCOUNT', state.list)
	},
	DES(state, value) {
		let a = state.list[state.index].mlptMenuFoodcategoryList
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					if (item.num > 0) {
						item.num--;
						state.count--
					}
					// if (state.count > 0) {
					// 	state.count--
					// }
				}
			})
		})
		console.log('DES', state.count)
	},
	DESCOUNT(state, value) {
		let a = state.list[state.index].mlptMenuFoodcategoryList
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					foodList.foodcategoryNum--

				}


			})
		})
		// console.log('a', a)
		console.log('DESCOUNT', state.list)
	},
	DES2(state, value) {
		let a = state.list[value.index].mlptMenuFoodcategoryList
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					if (item.num > 0) {
						item.num--;
						state.count--
					}
					// if (state.count > 0) {
					// 	state.count--
					// }
				}
			})
		})
		let d = state.list[value.index].mlptMenuFoodList
		d.forEach((food) => {
			if (food.id == value.id) {
				food.num--;
			}
		})
		console.log('DES2', state.count)
	},
	DESCOUNT2(state, value) {
		let a = state.list[value.index].mlptMenuFoodcategoryList
		a.forEach((foodList) => {
			foodList.foodcategoryList.forEach((item) => {
				if (item.id == value.id) {
					foodList.foodcategoryNum--

				}


			})
		})
		// console.log('a', a)
		console.log('DESCOUNT2', state.list)
	},
	SUBT(state, value) {
		state.sum -= value
	},
	setList(state, list) {
		state.list = list;
		console.log('addlist', state.list)
	},
	setIndex(state, value) {
		state.index = value;
		console.log('setIndex', state.index)
	},
	setCount(state, value) {
		state.count = value;
		console.log('setcount', state.count)
	},
	setLimit(state, value) {
		state.limit = value;
		console.log('state.limit', state.limit)
	},
	setShowlist(state, value) {
		state.showList = value;
		console.log('state.showList', state.showList)
	},

}
//state用于存储具体数据
const state = {
	list: [],
	count: 0,
	index: 0,
	limit: [],
	showList: [],
}

//创建并暴露（导出）store
export default new Vuex.Store({
	actions,
	mutations,
	state
})